<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_DESIGN_MARKETPLACE_PUBLICATION_TEMPLATES"
    align="left"
    width="full"
    :breadcrumbs="publicationTemplateBreadCrumbs"
    page-name="Publication Templates"
    title="Publication Templates"
  >
    <SmartFeed
      :pinia-store="usePublicationTemplateFeedStore"
      default-entity-layout="cardSmall"
      default-smart-feed-layout="grid"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_DESIGN_MARKETPLACE_PUBLICATION_TEMPLATES,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import { usePublicationTemplateFeedStore } from "SmartFeed/stores/feed/publication-template-feed-store";

export default {
  name: "DesignMarketplacePublicationTemplates",
  components: {
    SmartFeed,
    PageWrapper,
  },
  provide() {
    return {
      selectable: false,
    };
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_DESIGN_MARKETPLACE_PUBLICATION_TEMPLATES,
    };
  },
  computed: {
    publicationTemplateBreadCrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
      ];
    },
  },
  methods: {
    usePublicationTemplateFeedStore,
  },
};
</script>

